<template>
  <div class="txt-field">
    <van-field
      v-model="value"
      :label="label"
      clearable
      :placeholder="placeholder"
      @input="onChange"
    />
  </div>
</template>
<script>
import { Field } from "vant";

export default {
  components: {
    [Field.name]: Field,
  },
  props: {
    defaultValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "关键字",
    },
    placeholder: {
      type: String,
      default: "请输入关键字",
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  data() {
    return {
      value: "",
    };
  },
  created() {
    if (this.defaultValue) {
      this.value = this.defaultValue;
      this.$emit("update", this.defaultValue);
    }
  },
  methods: {
    onChange(value) {
      this.$emit("update", value);
    },
    setValue(value) {
      this.value = value;
      this.$emit("update", value);
    },
  },
};
</script>

<style lang="less" scoped>
.txt-field {
  /deep/.van-field {
    padding: 5px 0;
  }
}
</style>
